import React from "react";
import styles from "./GenericImageSquare.module.scss";
import SquareIcon from '../squareIcon/SquareIcon';
import LogoSquare from "./components/logoSquare/LogoSquare";
import SkeletonPlaceHolder from 'gui/components/skeletonPlaceHolder';


export interface IGenericImageSquareProps {
  className?: string;
  iconContainerClassName?: string;
  icon?: any;
  label?: string;
  logoSrc?: string | string[];
  logoTitle?: string;
  children?: any;
  loading?: boolean;
}


const GenericImageSquare = ({loading, ...props}: IGenericImageSquareProps) => (
  <span
    className={`${props.className} ${styles.GenericImageSquare} ${loading ? styles.loading : ''}`.trim()}
  >
    <SquareIcon
      icon={loading ? null : props.icon}
      iconElement={
        loading && <SkeletonPlaceHolder
          className={styles.iconClassName}
        />}
      toolTip={props.label}
      iconContainerClassName={`${props.iconContainerClassName} ${styles.iconContainerClassName}`.trim()}
      iconClassName={styles.iconClassName}
    />
    {loading ? <SkeletonPlaceHolder style={{width: "100%", height: "100%"}}/> : <LogoSquare
      logoSrc={props.logoSrc}
      logoTitle={props.logoTitle}
    />}
    {props.children}
  </span>
);

GenericImageSquare.defaultProps = {
  className: "",
  iconClassName: "",
  iconContainerClassName: '',
  label: "",
  logoSrc: "",
  loading: false,
};

export default GenericImageSquare;
